import { render, staticRenderFns } from "./LocationTaxPercentages.vue?vue&type=template&id=648b1504"
import script from "./LocationTaxPercentages.vue?vue&type=script&lang=js"
export * from "./LocationTaxPercentages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports